module.exports = __webpack_public_path__ + "media/notification_sound.3aa2bbb5.wav";